import Layout from "../components/layout/Layout";
import PointUsers from "../components/page/PointUsers";
import {PointServiceGuard} from "../components/ServiceGuard";

const PointUsersPage = () => {
  return (
    <Layout>
      {/* 가드는 Layout **안쪽**이다 — 사이드바를 남긴 채 안내만 보여줘야
          고객이 다른 메뉴로 이동할 수 있다(밖에 두면 사이드바 없는 맨 화면이 된다). */}
      <PointServiceGuard>
        <PointUsers />
      </PointServiceGuard>
    </Layout>
  );
};
export default PointUsersPage;
